import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants';
import { IAutoTaskConfigEmployee } from '../models';

export const useAutoTaskConfigEmployee = () => {
  const permissions = useAppSelector(state => state.userReducer.user?.role.permissions);
  const isAccessSettingsBotAutoTask = permissions?.includes(Permissions.PERMISSION_SETTINGS_AUTO_TASK);

  const data = useQuery<Record<string, IAutoTaskConfigEmployee[]>>({
    queryKey: [queryKeys.AUTO_TASK_CONFIG_EMPLOYEE],
    queryFn: async () => {
      const res = await $api.get('/v1/auto-task-setting/employee');

      return res?.data?.data;
    },
    enabled: isAccessSettingsBotAutoTask
  });

  const employeeArray = Object.entries(data?.data || {}).map(([k, v]) => ({
    label: k || 'Qolgan xodimlar',
    children: v?.map(item => ({
      label: item?.fullName,
      value: item?.id
    }))
  }));

  return { ...data, employeeArray };
};
